import React from 'react';
import { Card } from "react-bootstrap";
import face_christopher_stapenhurst from "../../assets/img/face_christopher_stapenhurst.jpg";
import ShowMoreText from "react-show-more-text";
import proj_stoch_coop_games from "../../assets/img/proj_stoch_coop_games.png";

const Chris_Stapenhurst_stoch_coop = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_stoch_coop_games} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_christopher_stapenhurst}
              /* this will be the text on the banner */
              alt="Stochastic Cooperative Games with Risk Averse Players"
            />{" "}
            <p className="text7">Christopher Stapenhurst</p>
            <br />
            <p className="text8">
              Postdoctoral Researcher{" "}
            </p>
            <p className="text8">QSMS Research Group, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            If the players of a cooperative game wish to create a stable coalition, then they 
            must share the surplus of the coalition so that every subset of players is better 
            off in the coalition than out of it. If the players are risk averse, then they may 
            benefit from sharing the surplus so as to provide insurance for the players. The 
            goal of this project is to study the interaction between stability and insurance -- 
            do they reinforce or undermine one another? The ideal student must be comfortable 
            with optimisation techniques. Knowledge of cooperative game theory and/or utility 
            theory is good, but not strictly necessary. For more information, 
            <a href="https://www.sciencedirect.com/science/article/pii/S0899825698906728">see</a>.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Chris_Stapenhurst_stoch_coop;